import React, { useState } from 'react';
import { Modal, Button, Checkbox, Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import BulkCandidatesDownloadFilterInfo from '../BulkCandidatesCriteria/BulkCandidatesDownloadFilterInfo';
import styles from './ContactPuller.module.scss';
import message from './ContactPullerMessage';

export default function ContactPuller(props) {
  const {
    visible,
    onCancel,
    candidateCount,
    eventCallbacks,
    availableCredits,
    isJobBoardSourcePresent,
    candidateDownloadFilterConfig,
    candidateCommunicationFilterConfig,
    userConfig,
  } = props;
  const [checked, setChecked] = useState(false);
  const activeTabDisplayName = userConfig?.ActiveChannelAlias || 'active';
  const availableCreditValue = availableCredits?.Arya?.AvailableCredits;
  const lowCreditMessage =
    isJobBoardSourcePresent && availableCreditValue < 1 ? (
      <span className={styles.lowCreditMessage}>
        Current available credits {availableCreditValue} may not pull contacts for some candidates. Please contact{' '}
        <a href="mailto:support@leoforce.com">support@leoforce.com</a> to secure more credits.
      </span>
    ) : null;

  const showCreditDeductionMessage = !(
    typeof availableCreditValue === 'string' && availableCreditValue?.toLowerCase() === 'unlimited'
  );

  return (
    <div>
      <Modal visible={visible} footer={null} closable={false} centered>
        <div className={styles.modalContainer}>
          <div className={styles.iconDiv}>
            <Icon type="question-circle" theme="filled" />
          </div>
          <div>
            <div className={styles.bulkConfirmation}>
              <FormattedMessage {...message.pullContactConfirmationMessage} values={{ candidateCount }} />
            </div>
            <p>{lowCreditMessage}</p>
            <Checkbox checked={checked} onChange={() => setChecked(!checked)}>
              <FormattedMessage {...message.checkedCandidateLabel} />
            </Checkbox>
            <BulkCandidatesDownloadFilterInfo
              candidateDownloadFilterConfig={candidateDownloadFilterConfig}
              candidateCommunicationFilterConfig={candidateCommunicationFilterConfig}
            />
            <div className={styles.actionButton}>
              <Button
                type="default"
                shape="round"
                style={{ marginRight: '8px' }}
                key="cancel-button"
                onClick={onCancel}
              >
                <FormattedMessage {...message.cancelButton} />
              </Button>
              <Button type="primary" shape="round" key="ok-button" onClick={() => eventCallbacks.onSend(checked)}>
                <FormattedMessage {...message.pullContactConfirmation} />
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
